<section
  [attr.id]="anchorLink ? anchorLink : null"
  class="tutoring-info__section"
  [attr.style]="
    sectionBackgroundColor
      ? 'background: ' + sectionBackgroundColor + ';'
      : null
  "
>
  <div class="tutoring-info__container {{ mediaRightPositionClass }}">
    @if (showVideo || showImage || showTutors) {
      <div class="video-component {{ mobileVideoPopupMedia }}">
        @if (showImage || showTutors) {
          <div class="video-component__media">
            @if (showImage) {
              <app-info-image [img]="imageSrc"></app-info-image>
            }
            @if (showTutors) {
              <app-tutor-cards></app-tutor-cards>
            }
          </div>
        }
        @if (showVideo) {
          <app-video
            [video]="videoSrcSet"
            [overlay]="overlayImageSrc"
            [overlayTitle]="imageAltText"
          ></app-video>
        }
      </div>
    }
    <div class="tutoring-info__text">
      @if (title && useLargeHeading) {
        <h1 class="tutoring-info__text__title" [bindHTML]="title"></h1>
      }
      @if (title && !useLargeHeading) {
        <h2 class="tutoring-info__text__title" [bindHTML]="title"></h2>
      }
      @if (subtitle) {
        <h3 class="tutoring-info__text__subtitle" [bindHTML]="subtitle"></h3>
      }
      @if (description) {
        <div
          class="tutoring-info__text__description"
          [bindHTML]="description"
        ></div>
      }
      @if (mobileVideoPopup && !hideButton) {
        <div class="tutoring-info__text__button {{ mobileVideoPopupMedia }}">
          <button (click)="showPopup()">
            @if (buttonText) {
              <span>
                {{ buttonText | translate }}
              </span>
            }
            @if (!buttonText) {
              <span>
                {{ "TutoringInfoSection_button" | translate }}
              </span>
            }
          </button>
        </div>
      }
      @if (!mobileVideoPopup && !hideButton) {
        <div class="tutoring-info__text__button">
          @if (!preparedLink.urlObject) {
            <a [routerLink]="[preparedLink.url] | localize">{{
              buttonText | translate
            }}</a>
          }
          @if (preparedLink.urlObject) {
            <a [href]="preparedLink.url">{{ buttonText | translate }}</a>
          }
        </div>
      }
    </div>
  </div>
  @if (contentsText) {
    <div class="tutoring-info__container tutoring-info__container__text">
      @for (content of contentsText; track content) {
        <app-info-text
          [title]="content.title"
          [subtitle]="content.subtitle"
          [description]="content.description"
        ></app-info-text>
      }
    </div>
  }
  @if (mobileVideoPopup && isVideoPopupVisible) {
    <app-info-popup
      [isVideoPopupVisible]="isVideoPopupVisible"
      (hidePopup)="hideVideoPopup()"
      [videoSrcSet]="videoSrcSet"
      [overlayImageSrc]="overlayImageSrc"
      [overlayTitle]="imageAltText"
    ></app-info-popup>
  }
</section>
